import {css} from 'lit';
export const styles = css`:host {
  --btn-more-color: var(--dark-text);

  font-size: var(--font-size-lg);
}

button {
  color: var(--btn-more-color);
  border: none;
  background: transparent;
}

@media (hover: hover) {

button {
    cursor: pointer
}

    button:hover {
      opacity: 0.5;
    }
  }

button:active {
    opacity: 0.8;
  }
`;
export default styles;
